import { render, staticRenderFns } from "./TimeTrackingWidget.vue?vue&type=template&id=0b7c3222"
import script from "./TimeTrackingWidget.vue?vue&type=script&lang=js"
export * from "./TimeTrackingWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports